import { render, staticRenderFns } from "./ImgWallBrick.vue?vue&type=template&id=3a628e02&"
import script from "./ImgWallBrick.vue?vue&type=script&lang=js&"
export * from "./ImgWallBrick.vue?vue&type=script&lang=js&"
import style0 from "./ImgWallBrick.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports